import { CARD_GESTURE_EVENT, CardGestureEventPayload } from './types';
import { addEventEmitterListenerPair } from './utils';

export const [emitCardGestureEvent, addCardGestureEventListener] =
  addEventEmitterListenerPair<CardGestureEventPayload>(CARD_GESTURE_EVENT);
